import React from 'react';
const IconMiscWalletFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 4V2H2V19C2 20.65 3.35 22 5 22H22V6H5C4.46 6 4 5.57 4 5V4H20ZM16 11.75C17.24 11.75 18.25 12.76 18.25 14C18.25 15.24 17.24 16.25 16 16.25C14.76 16.25 13.75 15.24 13.75 14C13.75 12.76 14.76 11.75 16 11.75Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscWalletFill;